import { API_ROUTE_ADMIN_DEPARTMENTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DepartmentOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getDepartmentsList = async () =>
  (
    await get<{ departments: DepartmentOriginal[] }>(
      API_ROUTE_ADMIN_DEPARTMENTS,
      IS_NEW_BACKEND_API
    )
  ).departments
